/**
 * Accorgersi che è uscita una versione nuova.
 *
 * L'indice della pagina nomina il pacchetto con un numero che cambia a ogni
 * pubblicazione. Un browser che tiene in cache l'indice resta su un pacchetto
 * vecchio, e chi lo usa vede correzioni già fatte come se non lo fossero: è
 * successo, e l'unico modo di uscirne era svuotare la cache a mano.
 *
 * Qui si controlla ogni tanto qual è il pacchetto pubblicato adesso. Se non è
 * più quello che sta girando, si avvisa - una volta sola, senza interrompere
 * niente: ricaricare è una scelta di chi sta scrivendo, non una cosa che
 * succede da sola mentre scrive.
 */

const OGNI = 10 * 60 * 1000;

function pacchettoInUso() {
  const script = document.querySelector('script[src*="/static/js/main."]');
  return script ? script.getAttribute("src") : null;
}

async function pacchettoPubblicato() {
  const risposta = await fetch("/asset-manifest.json", { cache: "no-store" });
  if (!risposta.ok) return null;
  const manifesto = await risposta.json();
  return manifesto?.files?.["main.js"] || null;
}

export function sorvegliaLaVersione(avvisa) {
  const inUso = pacchettoInUso();
  if (!inUso) return () => {};   // server di sviluppo: niente da confrontare
  let avvisato = false;

  const controlla = async () => {
    if (avvisato || document.hidden) return;
    try {
      const pubblicato = await pacchettoPubblicato();
      if (pubblicato && !inUso.endsWith(pubblicato.split("/").pop())) {
        avvisato = true;
        avvisa();
      }
    } catch {
      /* senza rete non si sa, e non importa: si riprova dopo */
    }
  };

  const battito = setInterval(controlla, OGNI);
  window.addEventListener("focus", controlla);
  setTimeout(controlla, 15000);
  return () => {
    clearInterval(battito);
    window.removeEventListener("focus", controlla);
  };
}
